import { defineMessages } from 'react-intl';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import config from '@plone/volto/registry';
import imageLeftSVG from '@plone/volto/icons/image-left.svg';
import imageRightSVG from '@plone/volto/icons/image-right.svg';
import blueCircleSVG from './icons/blue-circle.svg';
import redCircleSVG from './icons/red-circle.svg';

const messages = defineMessages({
  Banner: {
    id: 'Banner',
    defaultMessage: 'Banner',
  },
  AltText: {
    id: 'Alt text',
    defaultMessage: 'Alt text',
  },
  openLinkInNewTab: {
    id: 'Open in a new tab',
    defaultMessage: 'Open in a new tab',
  },
  AltTextHint: {
    id: 'Leave empty if the image is purely decorative.',
    defaultMessage: 'Leave empty if the image is purely decorative.',
  },
  AltTextHintLinkText: {
    id: 'Describe the purpose of the image.',
    defaultMessage: 'Describe the purpose of the image.',
  },
  BlockWidth: {
    id: 'Block Width',
    defaultMessage: 'Block Width',
  },
  Line1: {
    id: 'Line 1',
    defaultMessage: 'Line 1',
  },
  Line2: {
    id: 'Line 2',
    defaultMessage: 'Line 2',
  },
  ImagePosition: {
    id: 'Image position',
    defaultMessage: 'Bildposition',
  },
  ImageLeft: {
    id: 'Image left',
    defaultMessage: 'Bild links',
  },
  ImageRight: {
    id: 'Image right',
    defaultMessage: 'Bild rechts',
  },
  BackgroundColor: {
    id: 'Banner background color',
    defaultMessage: 'Hintergrundfarbe',
  },
  Blue: {
    id: 'Blue',
    defaultMessage: 'Blau',
  },
  Red: {
    id: 'Red',
    defaultMessage: 'Rot',
  },
});

export const BannerBlockSchema = (props) => {
  const { intl } = props;
  const schema = {
    block: intl.formatMessage(messages.Banner),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          ...(props.formData?.url
            ? [
                'alt',
                'text',
                'additionalText',
                'imagePosition',
                'backgroundColor',
              ]
            : []),
        ],
      },
    ],
    properties: {
      alt: {
        title: intl.formatMessage(messages.AltText),
        description: (
          <>
            <a
              href="https://www.w3.org/WAI/tutorials/images/decision-tree/"
              title={intl.formatMessage(messages.openLinkInNewTab)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {intl.formatMessage(messages.AltTextHintLinkText)}
            </a>{' '}
            {intl.formatMessage(messages.AltTextHint)}
          </>
        ),
      },
      text: {
        title: intl.formatMessage(messages.Line1),
      },
      additionalText: {
        title: intl.formatMessage(messages.Line2),
      },
      imagePosition: {
        title: intl.formatMessage(messages.ImagePosition),
        widget: 'buttons',
        actions: ['left', 'right'],
        actionsInfoMap: {
          left: [imageLeftSVG, intl.formatMessage(messages.ImageLeft)],
          right: [imageRightSVG, intl.formatMessage(messages.ImageRight)],
        },
        default: 'right',
      },
      backgroundColor: {
        title: intl.formatMessage(messages.BackgroundColor),
        widget: 'buttons',
        actions: ['blue', 'red'],
        actionsInfoMap: {
          blue: [blueCircleSVG, intl.formatMessage(messages.Blue)],
          red: [redCircleSVG, intl.formatMessage(messages.Red)],
        },
        default: 'blue',
      },
    },
    required: [],
  };

  addStyling({ schema, intl });

  schema.properties.styles.schema.fieldsets[0].fields = [
    'blockWidth:noprefix',
    ...schema.properties.styles.schema.fieldsets[0].fields,
  ];

  schema.properties.styles.schema.properties['blockWidth:noprefix'] = {
    widget: 'blockWidth',
    title: intl.formatMessage(messages.BlockWidth),
    default: 'layout',
    filterActions: ['layout', 'full'],
    actions: config.blocks.widths,
  };

  return schema;
};
